export enum BannerVariantEnum {
  DEFAULT = "default",
  IMPACT = "impact",
}
